<script>
    /**The id attribute of the label*/
    export let id;
    /**
     * The `name` attribute of the `select` element
    */
    export let name;
    /** 
     * The index of the selected item.
    */
    export let selected;
    /**
     * An array of strings, where each string represents an option.
     */
    export let options = [];
</script>

<div class="select-container">
    <label for={id}>
        <slot name="label"></slot>
    </label>
    <select bind:value={selected} id={id} name={name} {...$$restProps}>
        {#each options as option, idx}
        <option value={idx}>{option}</option>
        {/each}
    </select>
</div>


<style>
    select {
        appearance: none;
        border: 1px solid #cfd3d7;
        font-size: 1rem;
        background-image: url("data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E%3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' width='25px' height='15px' version='1.1' id='svg881' sodipodi:docname='example.svg' inkscape:version='0.92.5 (2060ec1f9f, 2020-04-08)'%3E%3Cmetadata id='metadata887'%3E%3Crdf:RDF%3E%3Ccc:Work rdf:about=''%3E%3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E%3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E%3C/cc:Work%3E%3C/rdf:RDF%3E%3C/metadata%3E%3Cdefs id='defs885' /%3E%3Csodipodi:namedview pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1' objecttolerance='10' gridtolerance='10' guidetolerance='10' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:window-width='2131' inkscape:window-height='804' id='namedview883' showgrid='false' inkscape:zoom='20.46367' inkscape:cx='12.5' inkscape:cy='7.9048282' inkscape:window-x='1867' inkscape:window-y='459' inkscape:window-maximized='0' inkscape:current-layer='svg881' /%3E%3Cpath d='M 3.8605,1.661481 H 20.904383 L 12.382442,15.048867' id='path879' inkscape:connector-curvature='0' style='fill:%23596e7c;stroke-width:0.78003943' /%3E%3C/svg%3E");        background-repeat: no-repeat;
        background-position: right center;
        padding-right: 1.3em;
        min-width: 150px;
    }

    select:focus, select:hover {
        border: 2px dashed #596e7cff;
        outline: none;
    }
</style>